export function phoneListExcel() {
  const button = document.querySelector('.js-phone-table-excel');

  if (button) {
    button.addEventListener('click', handleDownloadExcelClick);
  }
}

function handleDownloadExcelClick() {
  var data = document.querySelector('.js-phone-table');
  var file = XLSX.utils.table_to_book(data);
  var type = 'xlsx';

  XLSX.write(file, { bookType: type, bookSST: true, type: 'base64' });
  XLSX.writeFile(file, 'IFAU_Employees.' + type);
}
